module.exports = "/_next/static/images/img_list-2-6f9ff516cbd884d89994bf0d6abe5b99.webp";